import * as React from "react";
import {Window} from "@progress/kendo-react-dialogs";
import {useState} from "react";
import {Button} from "@progress/kendo-react-buttons";
import {TextBox, NumericTextBox, TextArea} from "@progress/kendo-react-inputs";
import {Label} from "@progress/kendo-react-labels";
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {DatePicker} from "@progress/kendo-react-dateinputs";

const statusOptions = [
    {value: 'pending', label: 'Ke zpracování'},
    {value: 'matched', label: 'Spárováno'},
    {value: 'unmatched', label: 'Nespárováno'},
    {value: 'ignored', label: 'Ignorováno'},
];

const EditBankNotificationDialog = (props) => {

    const {notification, onClose, onSave} = props;

    const [formData, setFormData] = useState({
        ...notification,
        TransactionDate: notification.TransactionDate ? new Date(notification.TransactionDate) : null
    });

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = () => {
        onSave(formData);
    };

    const formatter = new Intl.NumberFormat('cs-CZ', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <Window
            title={`Editace notifikace #${notification.ID}`}
            onClose={onClose}
            initialHeight={notification.NotificationType === 'sepa' ? 900 : 650}
            initialWidth={600}
            modal={true}
        >
            <div style={{padding: 16}}>
                <div style={{display: 'grid', gridTemplateColumns: '140px 1fr', gap: '12px', alignItems: 'center'}}>

                    <Label>Status:</Label>
                    <DropDownList
                        data={statusOptions}
                        textField="label"
                        dataItemKey="value"
                        value={statusOptions.find(s => s.value === formData.Status)}
                        onChange={(e) => handleChange('Status', e.value.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Datum transakce:</Label>
                    <DatePicker
                        value={formData.TransactionDate}
                        onChange={(e) => handleChange('TransactionDate', e.value)}
                        format="dd.MM.yyyy"
                        style={{width: '100%'}}
                    />

                    <Label>Částka:</Label>
                    <NumericTextBox
                        value={formData.Amount}
                        onChange={(e) => handleChange('Amount', e.value)}
                        format="n2"
                        style={{width: '100%'}}
                    />

                    <Label>Měna:</Label>
                    <TextBox
                        value={formData.Currency || ''}
                        onChange={(e) => handleChange('Currency', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Variabilní symbol:</Label>
                    <TextBox
                        value={formData.VariableSymbol || ''}
                        onChange={(e) => handleChange('VariableSymbol', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Konstantní symbol:</Label>
                    <TextBox
                        value={formData.ConstantSymbol || ''}
                        onChange={(e) => handleChange('ConstantSymbol', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Specifický symbol:</Label>
                    <TextBox
                        value={formData.SpecificSymbol || ''}
                        onChange={(e) => handleChange('SpecificSymbol', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Náš účet:</Label>
                    <TextBox
                        value={formData.OurAccount || ''}
                        onChange={(e) => handleChange('OurAccount', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Protiúčet:</Label>
                    <TextBox
                        value={formData.CounterpartyAccount || ''}
                        onChange={(e) => handleChange('CounterpartyAccount', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Název protiúčtu:</Label>
                    <TextBox
                        value={formData.CounterpartyName || ''}
                        onChange={(e) => handleChange('CounterpartyName', e.value)}
                        style={{width: '100%'}}
                    />

                    <Label>Zpráva:</Label>
                    <TextArea
                        value={formData.Message || ''}
                        onChange={(e) => handleChange('Message', e.value)}
                        rows={2}
                        style={{width: '100%'}}
                    />

                    {/* SEPA fields */}
                    {formData.NotificationType === 'sepa' && (
                        <>
                            <Label style={{gridColumn: '1 / -1', fontWeight: 'bold', marginTop: 8, borderTop: '1px solid #ddd', paddingTop: 8}}>
                                SEPA pole:
                            </Label>

                            <Label>Odesílatel:</Label>
                            <TextBox
                                value={formData.SenderName || ''}
                                onChange={(e) => handleChange('SenderName', e.value)}
                                style={{width: '100%'}}
                            />

                            <Label>IBAN:</Label>
                            <TextBox
                                value={formData.SenderIBAN || ''}
                                onChange={(e) => handleChange('SenderIBAN', e.value)}
                                style={{width: '100%'}}
                            />

                            <Label>BIC:</Label>
                            <TextBox
                                value={formData.SenderBIC || ''}
                                onChange={(e) => handleChange('SenderBIC', e.value)}
                                style={{width: '100%'}}
                            />

                            <Label>Důvod platby:</Label>
                            <TextArea
                                value={formData.PaymentReason || ''}
                                onChange={(e) => handleChange('PaymentReason', e.value)}
                                rows={2}
                                style={{width: '100%'}}
                            />

                            <Label>Ref. číslo KB:</Label>
                            <TextBox
                                value={formData.KBReference || ''}
                                onChange={(e) => handleChange('KBReference', e.value)}
                                style={{width: '100%'}}
                            />

                            <Label>Kurz:</Label>
                            <NumericTextBox
                                value={formData.ExchangeRate || 0}
                                onChange={(e) => handleChange('ExchangeRate', e.value)}
                                format="n4"
                                style={{width: '100%'}}
                            />
                        </>
                    )}

                    <Label>Poznámka:</Label>
                    <TextArea
                        value={formData.MatchNote || ''}
                        onChange={(e) => handleChange('MatchNote', e.value)}
                        rows={2}
                        style={{width: '100%'}}
                    />

                </div>

                {/* Actions */}
                <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24}}>
                    <Button
                        themeColor="base"
                        onClick={onClose}
                    >
                        Zrušit
                    </Button>
                    <Button
                        themeColor="primary"
                        onClick={handleSubmit}
                    >
                        Uložit
                    </Button>
                </div>
            </div>
        </Window>
    );
};

export default EditBankNotificationDialog;
